/**
 * VergleichScoreBadge — the Offer Score + rank + E4 chip for one offer (P2 Placement Slice 11, Tab 4b).
 */

import { VERGLEICH_E4_LABEL } from '@brokly/shared';
import { Badge } from '../../components/ui/Badge';

export function VergleichScoreBadge({ score, rang, e4 }: { score: number; rang: number; e4: boolean }) {
  return (
    <span className="inline-flex flex-wrap items-center gap-1" data-testid="vergleich-score-badge">
      <span className="[font-variant-numeric:tabular-nums] text-sm font-semibold">Score {score}</span>
      <Badge variant={rang === 1 ? 'success' : 'neutral'}>Rang {rang}</Badge>
      {e4 && <Badge variant="danger">{VERGLEICH_E4_LABEL}</Badge>}
    </span>
  );
}
